import { Capacitor } from '@capacitor/core';
import { SecureStorage, KeychainAccess } from '@aparajita/capacitor-secure-storage';

const SESSION_KEYS = ['accessToken', 'refreshToken', 'clientToken', 'clientRefreshToken', 'clientCaseId', 'clientEmail'];
const VAULT_KEY = 'portal-session-v1';
let queue = Promise.resolve();
let lastStorageError = null;

// Existing pages read these keys synchronously. In a native app their values live
// in memory, and the persisted copy is kept only in Keychain / Android Keystore.
export async function initializeSessionVault() {
  if (!Capacitor.isNativePlatform()) return;
  await SecureStorage.setKeyPrefix('cisowski-portal_');
  await SecureStorage.setSynchronize(false);
  await SecureStorage.setDefaultKeychainAccess(KeychainAccess.whenUnlockedThisDeviceOnly);
  const storage = window.localStorage;
  const originalGet = Storage.prototype.getItem;
  const originalSet = Storage.prototype.setItem;
  const originalRemove = Storage.prototype.removeItem;
  const originalClear = Storage.prototype.clear;
  let values = (await SecureStorage.get(VAULT_KEY)) || {};
  if (typeof values !== 'object' || Array.isArray(values)) throw new Error('Secure session storage is invalid.');
  // Remove any legacy plaintext credentials rather than migrating an old role.
  SESSION_KEYS.forEach(key => originalRemove.call(storage, key));
  const persist = () => {
    const snapshot = { ...values };
    queue = queue.catch(() => {}).then(() => SecureStorage.set(VAULT_KEY, snapshot)).catch(error => {
      lastStorageError = error;
      window.dispatchEvent(new CustomEvent('mobile-secure-storage-error'));
    });
  };
  Storage.prototype.getItem = function getItem(key) {
    return this === storage && SESSION_KEYS.includes(key) ? (values[key] ?? null) : originalGet.call(this, key);
  };
  Storage.prototype.setItem = function setItem(key, value) {
    if (this === storage && SESSION_KEYS.includes(key)) { values[key] = String(value); persist(); return; }
    originalSet.call(this, key, value);
  };
  Storage.prototype.removeItem = function removeItem(key) {
    if (this === storage && SESSION_KEYS.includes(key)) { delete values[key]; persist(); return; }
    originalRemove.call(this, key);
  };
  Storage.prototype.clear = function clear() {
    if (this === storage) { values = {}; persist(); }
    originalClear.call(this);
  };
}

export async function flushSessionVault() {
  await queue;
  if (lastStorageError) {
    const error = lastStorageError;
    lastStorageError = null;
    throw error;
  }
}
